import AnimatedSection from '../common/AnimatedSection'
import { productValues } from '../../data/siteData'

function ProductsValueBar() {
  return (
    <AnimatedSection className="products-value-section">
      <div className="container corp-container">
        <div className="products-value-grid" role="list">
          {productValues.map((item) => {
            const Icon = item.icon
            return (
              <div className="products-value-item" key={item.title} role="listitem">
                <span className="products-value-item__icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ProductsValueBar
